<template>
  <div id="page-login" class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCardGroup>
            <CCard>
              <CCardBody class="login-box position-relative">

                <div class="login-logo">
                  <!-- <img src="@/assets/logo.png">
                  <div class="member">
                    <img src="@/assets/agent2.png">
                  </div> -->
                  <div class="text-center py-4">
                    <h2 class="text-light">Agent Login</h2>
                  </div>
                </div>

                <CForm method="post" @submit.prevent="login">

                  <CInput
                    placeholder="Username"
                    autocomplete="username"
                    v-model="input.username"
                    required
                  ></CInput>

                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="input.password"
                    required
                  ></CInput>

                  <div class="text-center">
                    <button type="submit" class="btn-login"></button>
                  </div>
                </CForm>

                <loading
                  :active="isLoading"
                  :can-cancel="false"
                  :is-full-page="false"
                  background-color="#EBEDEF"
                  :height="30"
                  :width="30"
                  color="#007bff"
                />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import AuthService from '@/services/authService'
import Auth from '@/helpers/auth'
import Swal from 'sweetalert2'
import cAlert from '@/helpers/alert'

export default {
  name: 'Login',
  data() {
    return {
      isSubmit: false,
      input: {
        username: '',
        password: ''
      },
      isLoading: false
    }
  },
  methods: {
    login(e) {

      this.isLoading = true
      AuthService.login(this.input)
      .then(async (response)=>{
        console.log('response', response)
        if(response.success) {
          await Auth.saveLogin(response.data)
          this.$router.push({name: 'Dashboard'})
        }else{
          throw new Error(response?.data?.message)
        }
      })
      .catch((e)=>{
        console.log(e)
        cAlert({
          ...e,
          title: 'ไม่สำเร็จ',
          text: e.message || 'Username/Password ไม่ถูกต้อง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isLoading = false
      })
    }
  },
  mounted() {
    const viewport = document.querySelector("meta[name=viewport]")
    viewport.setAttribute('content', 'width=device-width,initial-scale=1.0')
  }
}
</script>
<style lang="scss">
#page-login {
  background-color: #000;
  background-image: url('../../assets/meatx.png');
  background-size: 100% 100%;
  background-position: center;

  .card {
    background-color: transparent;
    border: 0;

    .login-box {
      background-color: #222433;
      border-radius: 15px;
      padding-top: 0;
      padding-bottom: 0;
      box-shadow: 0 0 20px #000;

      .login-logo {
        img {
          width: 100%;
        }

        .member {
          text-align: right;
          margin-top: -60px;
          img {
            width: 50%;
          }
        }
      }

      form {
        padding: 0 30px;
        margin-top: -10px;

        .form-group {
          .form-control {
            border-radius: 0;
            background-color: transparent;
            border: 0;
            border-bottom: 1px solid gold;
            color: gold;
            padding: 0;
          }

          .form-control::placeholder {
            color: gold;
            opacity: 0.6;
          }

          .form-control:focus {
            outline: none !important;
            border: 0 !important;
            box-shadow: 0 0 10px #719ECE;
          }
        }

        .btn-login {
          border: 0;
          background-color: transparent;
          background-image: url('../../assets/login-btn.png');
          background-size: cover;
          width: 250px;
          height: 139px;
        }
      }
    }
  }
}
</style>
